export const tableFunds = {
    init: () => {
        const processTableFunds = () => {
            const tables = document.querySelectorAll(".c-table-funds--auto-dist");
            console.log("TableFunds init - Found tables:", tables.length);
            tables.forEach((table) => {
                const tableFundsRows = table.querySelectorAll(".c-table-funds_row");
                const tableFundsRowsAdditional = table.querySelectorAll(".c-table-funds_row-additional");
                const headerCells = table.querySelectorAll("th");
                const headersNumber = headerCells.length;
                console.log("TableFunds init - Processing table with:", {
                    regularRows: tableFundsRows.length,
                    additionalRows: tableFundsRowsAdditional.length,
                    headerCount: headersNumber
                });
                tableFundsRows.forEach((row, index) => {
                    if (index % 2 === 0) {
                        row.classList.add("c-table-funds_row--white");
                    }
                    else {
                        row.classList.add("c-table-funds_row--gray");
                    }
                });
                tableFundsRowsAdditional.forEach((row, index) => {
                    const tdElements = row.querySelectorAll(":scope > td");
                    console.log(`TableFunds init - Setting colspan ${headersNumber} on ${tdElements.length} td elements in additional row ${index}`);
                    tdElements.forEach((td) => {
                        td.setAttribute("colspan", headersNumber.toString());
                    });
                });
            });
        };
        processTableFunds();
        const tables = document.querySelectorAll(".c-table-funds--auto-dist");
        if (tables.length === 0) {
            console.log("TableFunds init - No tables found immediately, trying again after delay...");
            setTimeout(processTableFunds, 50);
        }
    },
};
